import React, { useContext } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import { ICONS } from '@Const/common'

interface WizardNextButtonProps {
    disabled?: boolean
}

const WizardNextButton = ({ disabled }: WizardNextButtonProps) => {
    const { wizardFlowStore } = useContext<RootStore>(StoresContext)

    const onPressed = async () => {
        const isStepValid = await wizardFlowStore.isCurrentStepValid()

        if (isStepValid) {
            if (
                wizardFlowStore.currentFlowStep?.forms &&
                wizardFlowStore.currentSubIndex !== wizardFlowStore.currentFlowStep?.forms.length - 1
            ) {
                wizardFlowStore.advanceSubIndex()
            } else if (wizardFlowStore.currentIndex < wizardFlowStore.flowLength - 1) {
                wizardFlowStore.advanceIndex()
                wizardFlowStore.setCurrentSubIndex(0)
            }
            window.scrollTo({
                top: 90,
                behavior: 'smooth',
            })
        }
    }

    return (
        <Button
            submitType="submit"
            mainColor
            type="primary"
            icon={ICONS.arrow_forward}
            onClick={onPressed}
            disabled={disabled}
        >
            Next
        </Button>
    )
}

export default observer(WizardNextButton)
